import {inject, Injectable} from '@angular/core';
import {type V4Response} from '../../services/apis/api-base.type';
import {V4HttpClient} from '../../services/apis/v4-http.client';
import {RegionService} from '../../services/region.service';

export interface IspOrgListItem {
  id: string;
  name: string | null;
  role_name: string | null;
}

export interface IspOrgInfo {
  id: string;
  name: string | null;
  owner_id: string | null;
  owner_name: string | null;
  created_at: string | null;
  remark: string | null;
  region: string | null;
  parent_org_id: string | null;
}

export interface IspOrgMemberItem {
  id: string;
  user_id: string;
  org_id: string;
  role_name: string | null;
  remark: string | null;
  created_at: string | null;
  username: string | null;
  name: string | null;
  nickname: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class IspOrgApiService {
  private readonly v4Http = inject(V4HttpClient);
  private readonly regionService = inject(RegionService);

  private get baseUrl(): string {
    return this.regionService.env.apiPrefix.ispV4;
  }

  private post<T>(path: string, body: unknown = {}): Promise<V4Response<T>> {
    return this.v4Http.post<T>(`${this.baseUrl}${path}`, body);
  }

  getUserOrgList() {
    return this.post<{items: IspOrgListItem[]; total: number}>('/org/user-org-list', {});
  }

  getOrgInfo(params: {org_id?: string} = {}) {
    return this.post<IspOrgInfo>('/org/info', params);
  }

  getOrgMemberList() {
    return this.post<{items: IspOrgMemberItem[]; total: number}>('/org/member/list', {});
  }

  addOrgMember(params: {username: string; role_name: string; remark?: string | null}) {
    return this.post<null>('/org/member/add', params);
  }

  removeOrgMember(params: {user_id: string}) {
    return this.post<null>('/org/member/remove', params);
  }
}
